<template>
  <section class="py-3 py-md-5 py-xl-8">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6 text-center">
          <h2 class="mb-4 display-5">Berita</h2>
          <p class="text-secondary mb-5 lead fs-4">
            Berita Resmi Kepegawaian Kabupaten Kendal.
          </p>
          <!-- 🔍 Form Pencarian -->
          <form @submit.prevent="handleSearch" class="row justify-content-center">
            <div class="col-12 col-lg-10">
              <input type="text" class="form-control bsb-form-control-3xl" placeholder="Cari berita..."
                v-model="searchQuery" />
            </div>
            <div class="col-12 col-lg-2 mt-3 mt-lg-0">
              <button type="submit" class="btn btn-primary w-100 bsb-btn-3xl">Cari</button>
            </div>
          </form>
          <hr class="w-50 mx-auto mb-5 border-dark-subtle" />
        </div>
      </div>
    </div>

    <!-- 📰 List Berita -->
    <div class="container overflow-hidden">
      <div v-if="paginatedNews.length" class="row gy-3 gx-xxl-5">
        <div v-for="news in paginatedNews" :key="news.id" class="col-12 col-lg-4">
          <article>
            <figure class="rounded overflow-hidden mb-3 bsb-overlay-hover">
              <router-link :to="`/berita/${news.id}`">

                <img class="img-fluid bsb-scale bsb-hover-scale-up" loading="lazy"
                  :src="`http://bkpsdm.kendalkab.go.id/bahurekso/packages/photo/${news.fav}`" :alt="news.titel" />
              </router-link>
              <figcaption>
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                  class="bi bi-eye text-white bsb-hover-fadeInLeft" viewBox="0 0 16 16">
                  <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8z" />
                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z" />
                </svg>
                <h4 class="h6 text-white bsb-hover-fadeInRight mt-2">Read More</h4>
              </figcaption>
            </figure>
            <div class="entry-header mb-3">
              <ul class="entry-meta list-unstyled d-flex mb-2">
                <li>
                  <a class="link-primary text-decoration-none" href="#!">{{
                    news.kategori
                    }}</a>
                </li>
              </ul>
              <h2 class="entry-title h4 mb-0">
                <router-link :to="`/berita/${news.id}`" class="link-dark text-decoration-none">{{
                  news.titel
                  }}</router-link>

              </h2>
            </div>
            <div class="entry-footer">
              <ul class="entry-meta list-unstyled d-flex align-items-center mb-0">
                <li>
                  <a class="fs-7 link-secondary text-decoration-none d-flex align-items-center" href="#!">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                      class="bi bi-calendar3" viewBox="0 0 16 16">
                      <path d="M14 0H2a2 2 0 0 0-2 2v12..." />
                    </svg>
                    <span class="ms-2 fs-7">{{ formatDate(news.created_at) }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </article>
        </div>
      </div>

      <!-- 🔄 Loading & Error -->
      <div v-else-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary"></div>
        <p class="mt-2">Memuat berita...</p>
      </div>
      <div v-else-if="error" class="text-danger text-center py-5">
        {{ error }}
      </div>

      <!-- 📄 Pagination -->
      <nav v-if="totalPages > 1" class="mt-5">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">
              &laquo;
            </button>
          </li>

          <li v-for="page in displayedPages" :key="page" class="page-item"
            :class="{ active: currentPage === page, disabled: page === '...' }">
            <button class="page-link" @click="changePage(page)">
              {{ page }}
            </button>
          </li>

          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">
              &raquo;
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</template>


<style>
.fs-7 {
  font-size: .875rem !important
}

.mb-8 {
  margin-bottom: 4.5rem !important
}

.mb-9 {
  margin-bottom: 5rem !important
}

.mb-auto {
  margin-bottom: auto !important
}

.py-8 {
  padding-bottom: 4.5rem !important;
  padding-top: 4.5rem !important
}

.py-9 {
  padding-bottom: 5rem !important;
  padding-top: 5rem !important
}

@media(min-width:576px) {
  .mb-sm-8 {
    margin-bottom: 4.5rem !important
  }

  .mb-sm-9 {
    margin-bottom: 5rem !important
  }

  .mb-sm-auto {
    margin-bottom: auto !important
  }

  .py-sm-8 {
    padding-bottom: 4.5rem !important;
    padding-top: 4.5rem !important
  }

  .py-sm-9 {
    padding-bottom: 5rem !important;
    padding-top: 5rem !important
  }
}

@media(min-width:768px) {
  .mb-md-8 {
    margin-bottom: 4.5rem !important
  }

  .mb-md-9 {
    margin-bottom: 5rem !important
  }

  .mb-md-auto {
    margin-bottom: auto !important
  }

  .py-md-8 {
    padding-bottom: 4.5rem !important;
    padding-top: 4.5rem !important
  }

  .py-md-9 {
    padding-bottom: 5rem !important;
    padding-top: 5rem !important
  }
}

@media(min-width:992px) {
  .mb-lg-8 {
    margin-bottom: 4.5rem !important
  }

  .mb-lg-9 {
    margin-bottom: 5rem !important
  }

  .mb-lg-auto {
    margin-bottom: auto !important
  }

  .py-lg-8 {
    padding-bottom: 4.5rem !important;
    padding-top: 4.5rem !important
  }

  .py-lg-9 {
    padding-bottom: 5rem !important;
    padding-top: 5rem !important
  }
}

@media(min-width:1200px) {
  .mb-xl-8 {
    margin-bottom: 4.5rem !important
  }

  .mb-xl-9 {
    margin-bottom: 5rem !important
  }

  .mb-xl-auto {
    margin-bottom: auto !important
  }

  .py-xl-8 {
    padding-bottom: 4.5rem !important;
    padding-top: 4.5rem !important
  }

  .py-xl-9 {
    padding-bottom: 5rem !important;
    padding-top: 5rem !important
  }
}

@media(min-width:1400px) {
  .mb-xxl-8 {
    margin-bottom: 4.5rem !important
  }

  .mb-xxl-9 {
    margin-bottom: 5rem !important
  }

  .mb-xxl-auto {
    margin-bottom: auto !important
  }

  .py-xxl-8 {
    padding-bottom: 4.5rem !important;
    padding-top: 4.5rem !important
  }

  .py-xxl-9 {
    padding-bottom: 5rem !important;
    padding-top: 5rem !important
  }
}

.bsb-animated {
  --bsb-animation-duration: 1s;
  animation-duration: var(--bsb-animation-duration);
  animation-fill-mode: both
}

@keyframes bsb-fadeIn {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

.bsb-fadeIn {
  animation-name: bsb-fadeIn
}

@keyframes bsb-fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 100%, 0)
  }

  to {
    opacity: 1;
    transform: translateZ(0)
  }
}

.bsb-fadeInUp {
  animation-name: bsb-fadeInUp
}

@keyframes bsb-fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0)
  }

  to {
    opacity: 1;
    transform: translateZ(0)
  }
}

.bsb-fadeInDown {
  animation-name: bsb-fadeInDown
}

@keyframes bsb-fadeInLeft {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0)
  }

  to {
    opacity: 1;
    transform: translateZ(0)
  }
}

.bsb-fadeInLeft {
  animation-name: bsb-fadeInLeft
}

@keyframes bsb-fadeInRight {
  0% {
    opacity: 0;
    transform: translate3d(100%, 0, 0)
  }

  to {
    opacity: 1;
    transform: translateZ(0)
  }
}

.bsb-fadeInRight {
  animation-name: bsb-fadeInRight
}

@keyframes bsb-fadeOut {
  0% {
    opacity: 1
  }

  to {
    opacity: 0
  }
}

.bsb-fadeOut {
  animation-name: bsb-fadeOut
}

@keyframes bsb-fadeOutUp {
  0% {
    opacity: 1
  }

  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0)
  }
}

.bsb-fadeOutUp {
  animation-name: bsb-fadeOutUp
}

@keyframes bsb-fadeOutDown {
  0% {
    opacity: 1
  }

  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0)
  }
}

.bsb-fadeOutDown {
  animation-name: bsb-fadeOutDown
}

@keyframes bsb-fadeOutLeft {
  0% {
    opacity: 1
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0)
  }
}

.bsb-fadeOutLeft {
  animation-name: bsb-fadeOutLeft
}

@keyframes bsb-fadeOutRight {
  0% {
    opacity: 1
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0)
  }
}

.bsb-fadeOutRight {
  animation-name: bsb-fadeOutRight
}

@keyframes bsb-zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(.3, .3, .3)
  }

  50% {
    opacity: 1
  }
}

.bsb-zoomIn {
  animation-name: bsb-zoomIn
}

.bsb-overlay {
  --bsb-overlay-opacity: 0.5;
  --bsb-overlay-bg-color: var(--bs-black-rgb);
  position: relative
}

.bsb-overlay:after {
  background-color: rgba(var(--bsb-overlay-bg-color), var(--bsb-overlay-opacity));
  bottom: 0;
  content: "";
  display: block;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 0
}

.bsb-overlay>* {
  position: relative;
  z-index: 1
}

.bsb-overlay-figure {
  --bsb-overlay-figure-opacity: 0.5;
  --bsb-overlay-figure-bg-color: var(--bs-black-rgb);
  position: relative
}

.bsb-overlay-figure:after {
  background-color: rgba(var(--bsb-overlay-figure-bg-color), var(--bsb-overlay-figure-opacity));
  bottom: 0;
  content: "";
  display: block;
  left: 0;
  position: absolute;
  right: 0;
  top: 0
}

.bsb-overlay-hover {
  --bsb-overlay-hover-opacity: 0.5;
  --bsb-overlay-hover-bg-color: var(--bs-black-rgb);
  position: relative
}

.bsb-overlay-hover>a {
  bottom: 0;
  display: block;
  left: 0;
  position: relative;
  right: 0;
  top: 0
}

.bsb-overlay-hover>a>img.bsb-scale {
  --bsb-scale: 1
}

.bsb-overlay-hover>a>img.bsb-scale,
.bsb-overlay-hover>a>img.bsb-scale-up {
  transform: scale3d(var(--bsb-scale), var(--bsb-scale), var(--bsb-scale));
  transform-style: preserve-3d;
  transition: transform .5s
}

.bsb-overlay-hover>a>img.bsb-scale-up {
  --bsb-scale: 1.2
}

.bsb-overlay-hover>a:after {
  background-color: rgba(var(--bsb-overlay-hover-bg-color), var(--bsb-overlay-hover-opacity));
  content: "";
  cursor: pointer !important;
  display: block;
  z-index: 0
}

.bsb-overlay-hover>a:after,
.bsb-overlay-hover>figcaption {
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0
}

.bsb-overlay-hover>figcaption {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  pointer-events: none;
  z-index: 1
}

.bsb-overlay-hover>figcaption>* {
  opacity: 0
}

.bsb-overlay-hover:hover>a>img.bsb-hover-scale {
  --bsb-scale-hover: 1;
  transform: scale3d(var(--bsb-scale-hover), var(--bsb-scale-hover), var(--bsb-scale-hover))
}

.bsb-overlay-hover:hover>a>img.bsb-hover-scale-up {
  --bsb-scale-hover: 1.2;
  transform: scale3d(var(--bsb-scale-hover), var(--bsb-scale-hover), var(--bsb-scale-hover))
}

.bsb-overlay-hover:hover>a:after {
  opacity: 1;
  transition: opacity .15s linear
}

.bsb-overlay-hover:hover>figcaption {
  opacity: 1;
  transition: opacity .15s linear .1s
}

.bsb-overlay-hover:hover>figcaption>.bsb-hover-fadeIn {
  --bsb-animation-duration: 500ms;
  animation-duration: var(--bsb-animation-duration);
  animation-fill-mode: both;
  animation-name: bsb-fadeIn
}

.bsb-overlay-hover:hover>figcaption>.bsb-hover-fadeInUp {
  --bsb-animation-duration: 500ms;
  animation-duration: var(--bsb-animation-duration);
  animation-fill-mode: both;
  animation-name: bsb-fadeInUp
}

.bsb-overlay-hover:hover>figcaption>.bsb-hover-fadeInDown {
  --bsb-animation-duration: 500ms;
  animation-duration: var(--bsb-animation-duration);
  animation-fill-mode: both;
  animation-name: bsb-fadeInDown
}

.bsb-overlay-hover:hover>figcaption>.bsb-hover-fadeInLeft {
  --bsb-animation-duration: 500ms;
  animation-duration: var(--bsb-animation-duration);
  animation-fill-mode: both;
  animation-name: bsb-fadeInLeft
}

.bsb-overlay-hover:hover>figcaption>.bsb-hover-fadeInRight {
  --bsb-animation-duration: 500ms;
  animation-duration: var(--bsb-animation-duration);
  animation-fill-mode: both;
  animation-name: bsb-fadeInRight
}

.bsb-overlay-hover:hover>figcaption>.bsb-hover-zoomIn {
  --bsb-animation-duration: 500ms;
  animation-duration: var(--bsb-animation-duration);
  animation-fill-mode: both;
  animation-name: bsb-zoomIn
}
</style>
<style>
.pagination .page-item.active .page-link {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.page-link {
  cursor: pointer;
}
</style>
<script>


import axios from "axios";
import dayjs from 'dayjs';

export default {
  name: "PengumumanView",
  data() {
    return {
      newsList: [],
      searchQuery: "",
      filteredList: [],
      loading: true,
      error: null,
      currentPage: 1,
      perPage: 6,
    };
  },
  components: {
    // PaginationC,
  },
  computed: {
    totalPages() {
      return Math.ceil(this.filteredList.length / this.perPage);
    },
    paginatedNews() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredList.slice(start, end);
    },
    displayedPages() {
      const pages = [];
      if (this.totalPages <= 5) {
        for (let i = 1; i <= this.totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        if (this.currentPage > 3) pages.push("...");
        for (
          let i = Math.max(2, this.currentPage - 1);
          i <= Math.min(this.totalPages - 1, this.currentPage + 1);
          i++
        ) {
          pages.push(i);
        }
        if (this.currentPage < this.totalPages - 2) pages.push("...");
        pages.push(this.totalPages);
      }
      return pages;
    },
  },

  methods: {

    getFormattedMonthWithDayjs(dateStringFromApi) {
      return dayjs(dateStringFromApi).format('MMM');
    },
    getFormattedDateWithDayjs(dateStringFromApi) {
      return dayjs(dateStringFromApi).format('dd');
    },
    async fetchNews() {
      try {

        this.loading = true;
        const response = await axios.get("/content/berita?pages=1&limit=100");
        console.log("Response data:", response.data);
        if (Array.isArray(response.data.data)) {
          this.newsList = response.data.data || [];
          this.filteredList = this.newsList;
        } else {
          console.error("Data tidak berbentuk array:", response.data);
          this.error = "Format data tidak valid";
        }
      } catch (err) {
        this.error = "Gagal memuat berita. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      const q = this.searchQuery.toLowerCase();
      this.filteredList = this.newsList.filter(
        (n) =>
          n.titel.toLowerCase().includes(q) ||
          n.desc?.toLowerCase().includes(q) ||
          n.kategori?.toLowerCase().includes(q)
      );
      this.currentPage = 1;
    },
    changePage(page) {
      if (page === "..." || page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("id-ID", options);
    },
  },
  created() {
    this.fetchNews();
  },
};
</script>